/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseExamSessionResponseData } from './genericApiResponseExamSessionResponseData';
import type { GenericApiResponseExamSessionResponseMessage } from './genericApiResponseExamSessionResponseMessage';
import type { GenericApiResponseExamSessionResponsePagination } from './genericApiResponseExamSessionResponsePagination';
import type { GenericApiResponseExamSessionResponseError } from './genericApiResponseExamSessionResponseError';

export interface GenericApiResponseExamSessionResponse {
  data?: GenericApiResponseExamSessionResponseData;
  message?: GenericApiResponseExamSessionResponseMessage;
  pagination?: GenericApiResponseExamSessionResponsePagination;
  error?: GenericApiResponseExamSessionResponseError;
  statusCode?: number;
}
